import Image from "next/image";

export type LogoProps = Omit<
	React.ComponentProps<typeof Image>,
	"src" | "alt"
> & {
	className?: string;
};

const Logo = ({ className, ...props }: LogoProps) => (
	<div className="h-8 w-8 rounded-full bg-black dark:bg-white flex items-center justify-center">
		<Image
			src="/logo.png"
			alt="Ploy"
			width={24}
			height={24}
			className={className}
			{...props}
		/>
	</div>
);

export default Logo;
